const STOCKS_TAB_KEY = 'screener_mainTab';

function getInitialStocksTab(pathname) {
  if (pathname === "/screener") return 1;
  const saved = sessionStorage.getItem(STOCKS_TAB_KEY);
  return saved != null ? Number(saved) : 0;
}

function saveStocksTab(tab) {
  sessionStorage.setItem(STOCKS_TAB_KEY, String(tab));
}

export { getInitialStocksTab, saveStocksTab };
